module.exports = __webpack_public_path__ + "static/media/logout.f022a724.svg";